<template>
  <article>
    <div>
      <div class="fs-16">主模块</div>
      <div class="function-list flex fw">
<!--         <div class="function-container mt-10 fc-6 fs-18 pointer relative" @click="go(1, '/moduleSingleUserList')">
          <div>系统</div>
          <div class="fs-12 function-manage absolute fc-2b">管理</div>
        </div> -->
        <div class="function-container mt-10 fc-6 fs-18 pointer relative" @click="go(1, '/adList')">
          <div>贝贝家</div>
          <div class="fs-12 function-manage absolute fc-2b">管理</div>
        </div>
        <div class="function-container mt-10 fc-6 fs-18 pointer relative" @click="go(2, '/shopGoodsList')">
          <div>电商</div>
          <div class="fs-12 function-manage absolute fc-2b">管理</div>
        </div>
        <div class="function-container mt-10 fc-6 fs-18 pointer relative" @click="go(3, '/taskList')">
          <div>任务墙</div>
          <div class="fs-12 function-manage absolute fc-2b">管理</div>
        </div>
      </div>
    </div>
  </article>
</template>
<style scoped>
  .function-container{
    width: 180px;
    height: 80px;
    background-color: #f5f5f5;
    border-radius: 4px;
    margin-right: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .function-container:hover{
    /*color: #0088FF;*/
    /*border-color: #0088FF;*/
    background-color: #0088ff;
    color: #fff;
  }
  .function-manage{
    right: 4px;
    bottom: 4px;
  }
  @media screen and (max-width: 768px){
    .function-list{
      justify-content: space-between;
    }
    .function-container{
      margin-right: 0;
      width: calc((100% - 12px) / 2);
    }
  }
</style>
<script>
import util from '../../script/util'
export default {
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
    go (market, url) {
      this.$emit('functionChange', market)
      util.setCookie('market', market)
      this.$router.push(url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/module/list.vue